import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from 'react'
import Main from './Main'
import './App.css';
import Login from "./Login";
import Main1 from "./Main1";
import Wheel from "./Wheel";

function App() {
  const segments = [
    { content: '1', color: '#ff6b6b' },
    { content: '2', color: '#4ecdc4' },
    { content: '3', color: '#45b7d1' },
    { content: '4', color: '#96ceb4' },
    { content: '5', color: '#ffda9e' }
  ];
  return (
    // <div>
    //   <Wheel
    //     segments={segments}
    //     predeterminedWinner={4} // Always lands on 3 (0-based index)
    //     spinDuration={5000}
    //     onSpinComplete={(winner) => console.log('Winner:', winner)}
    //     dailySpinLimit={true}
    //     buttonColor="#45b7d1"
    //     arrowColor="#2f3542"
    //     size={500}
    //   />
    // </div>
    <Router>
      <Routes>
        <Route path="/:id/:user" element={<Main />} />
        <Route path="/:id" element={<Main1 />} />
        <Route path="/:id/login" element={<Login />} />
      </Routes>
    </Router>
  )
}

export default App